/**
 * Visible product name. One constant so the app never shows several brands
 * again (audit RUI-15, F1). Technical identifiers (rvk_ key prefix, cookie
 * and database names) keep "revcall" and do not read this.
 */
export const BRAND = {
  name: 'XDial',
} as const;
